/* unplugin-vue-components disabled */import script from "./oppoDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./oppoDetail.vue?vue&type=script&setup=true&lang=ts"

import "./oppoDetail.vue?vue&type=style&index=0&id=54dcd3f8&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54dcd3f8"]])

export default __exports__